import axios from 'axios'
import {withRouter} from 'react-router-dom'
import React, { useState, useRef } from 'react'
import { Form, NavDropdown, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { enStyle } from '../../style/enStyle'
import { faStyle } from '../../style/faStyle'
import SimpleReactValidator from 'simple-react-validator'
import './style.scss'
import { Link } from 'react-router-dom'
import { fetchCsrfCookie } from '../../redux/action/csrf/csrf-cookie'
import { useDispatch } from 'react-redux'
import {IoCloseCircleOutline} from 'react-icons/io5'

const RegisterAdmin = ({history}) => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [confirmLogo, setConfirmLogo] = useState(false)
    const [errors, setErrors] = useState({})
    const [registerForm, setRegisterForm] = useState(true)
    const [cofirmed, setCofirmed] = useState(false)
    const [typingTimeout, setTypingTimeout] = useState(0)
    const [forceUpdate, setForceUpdate] = useState(false)
    let dispatch = useDispatch()

    const [data, setData] = useState({
        title: "",
        manager_name: "",
        manager_mobile: "",
        username: "",
        password: "",
        confirm_password: "",
    })
    const {t, i18n} = useTranslation();

    const changeHandler = event => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const confirmPasswordHandler = event => {
        setData({ ...data, [event.target.name]: event.target.value })
        if (typingTimeout) { 
            clearTimeout(typingTimeout) 
        }
        setTypingTimeout(setTimeout(function () {
            if(data.password !== event.target.value ) {
                setConfirmLogo(true)
            } else {
                setConfirmLogo(false)
            }
        }, 1000))
    }

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است",
          min:"تعداد کاراکترهای ورودی کم است"
        },
    }))

    const changeLangToFa = () => { localStorage.setItem("lang", "fa"); i18n.changeLanguage("fa"); faStyle() }
    const changeLangToEn = () => { localStorage.setItem("lang", "en"); i18n.changeLanguage("en"); enStyle() }
    const changeLangToAr = () => { localStorage.setItem("lang", "ar"); i18n.changeLanguage("ar"); faStyle() }

    const handleFromSubmit = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            dispatch(fetchCsrfCookie())
            axios.post('auth/register', data, {withCredentials: true})
            .then(res => {
                setBtnLoading(false)
                setRegisterForm(false)
                setCofirmed(true)
            })
            .catch(err => {
                setBtnLoading(false)
                setErrors(err.response.data.errors)
                err.response.data.errors.username && toast.error('نام کاربری قبلا ثبت شده است' , {position: 'bottom-right'})
                err.response.data.errors.manager_mobile && toast.error('شماره همراه قبلا ثبت شده است' , {position: 'bottom-right'})
                err.response.data.errors.confirm_password && toast.error('تکرار رمز عبور مطابقت ندارد' , {position: 'bottom-right'})
            })
        } else if (data.password !== data.confirm_password) {
            setBtnLoading(false)
            setConfirmLogo(true)
            toast.error(t("toast_repeat_password_does_not_match") , {position: 'bottom-right'})
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    return (
        <div className="register">
            <div className='registerLang'>
                <NavDropdown title={t("lang")} id="authlang">
                    <h6 onClick={changeLangToFa}><img src="/assets/img/icons/fa.png" alt="fa" />{t("fa")}</h6>
                    <h6 onClick={changeLangToEn}><img src="/assets/img/icons/en.png" alt="en" />{t("en")}</h6>
                    <h6 onClick={changeLangToAr}><img src="/assets/img/icons/ar.png" alt="ar" />{t("ar")}</h6>
                </NavDropdown>
            </div>
            <Row>
                <div className="col-lg-6 p-0">
                    <div className="register-image">
                        <img src="./assets/img/3.jpg" alt="register" className="register-bg" />
                        <div className="register-content ">
                            <h2 className='animate__animated animate__fadeInDown'> {t("login_content_title")} </h2>
                            <p className='animate__animated animate__fadeInDown'>
                                {t("login_content_info_1")}<br/>
                                {t("login_content_info_2")}<br />
                                {t("login_content_info_3")}
                            </p>
                        </div>
                    </div>
                </div>
                {registerForm === true &&
                    <div className="col-lg-6 p-0">
                        <div className="register-form">
                            <div className="segment">
                                <h1>{t("company registration")}</h1>
                                <p>{t("To register your company in the virtual exhibition, fill out the form below")}</p>
                            </div>
                            <Form >
                                <div className='register-item'>
                                    <label>
                                        <input type="text" name="title" placeholder={t("company name")} value={data.title} onChange={changeHandler} />
                                        <span className='validator_error'>{validator.current.message('title', data.title, 'required')}</span>
                                    </label>
                                </div>    

                                <div className='register-item'>
                                    <label>
                                        <input type="text" name="manager_name" placeholder={t("CEO name")} value={data.manager_name} onChange={changeHandler} />
                                        <span className='validator_error'>{validator.current.message('manager_name', data.manager_name, 'required')}</span>
                                    </label>
                                </div>

                                <div className='register-item'>
                                    <label>
                                        <input type="text" name="manager_mobile" placeholder={t("CEO phone number")} value={data.manager_mobile} onChange={changeHandler} />
                                        <span className='validator_error'>{validator.current.message('manager_mobile', data.manager_mobile, 'required|min:11')}</span>
                                    </label>
                                </div>

                                <div className='register-item'>
                                    <label>
                                        <input type="text" name="username" placeholder={t("username")} value={data.username} onChange={changeHandler} />
                                        <span className='validator_error'>{validator.current.message('username', data.username, 'required')}</span>
                                    </label>
                                </div>
                                
                                <div className='register-item'>
                                    <label>
                                        <input type="password" name="password" placeholder={t("password")} value={data.password} onChange={confirmPasswordHandler} />
                                        <span className='validator_error'>{validator.current.message('password', data.password, 'required|min:8')}</span>
                                    </label>
                                </div>

                                <div className='register-item'>
                                    <label>
                                        {confirmLogo ? <IoCloseCircleOutline title='تکرار رمز عبور مطابقت ندارد' className='pass_validator' /> : "" }
                                        <input type="password" placeholder={t("repeat password")} type="password" name="confirm_password" value={data.confirm_password} onChange={confirmPasswordHandler} />
                                        <span className='validator_error'>{validator.current.message('confirm_password', data.confirm_password, 'required|min:8')}</span>
                                    </label>
                                </div>

                                <button className={btnLoading ? 'green btn-disabled' : 'green'} disabled={btnLoading ? true : false} type="button" onClick={handleFromSubmit}>{t("company registration")}</button>
                                <div className="text-center mt-4 forget_your_password">
                                    {t("Already a member")}<Link to="/login">{t("login")}</Link>
                                </div>
                            </Form>
                        </div>
                    </div>
                }
                {cofirmed && 
                    <div className="col-lg-6">
                        <div className="register-form">
                            <div className="segment">
                                <h1>{t("new company has been registered")}</h1>
                                <p> {t("you can log in via the link below")} </p>
                            </div>
                            <Link to="/login" className="col-lg-4 btn btn-success btn-lg">{t("login")}</Link>
                        </div>
                    </div>
                }
            </Row>
        </div>
    )
}

export default withRouter(RegisterAdmin)
